import React, { useEffect, useRef } from "react";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";

interface EmojiPickerProps {
  onEmojiSelect: (emoji: any) => void;
}

const EmojiPicker: React.FC<EmojiPickerProps> = ({ onEmojiSelect }) => {
  const pickerRef = useRef<HTMLDivElement>(null);
  const [isClient, setIsClient] = React.useState(false);

  useEffect(() => {
    setIsClient(true);
    // Log to confirm if Picker component is being initialized
    console.log("EmojiPicker: isClient set to true");
  }, []);

  if (!isClient) return null;

  return (
    <div
      ref={pickerRef}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <Picker
        data={data}
        onEmojiSelect={(emoji: any) => {
          console.log("Emoji selected:", emoji);
          onEmojiSelect(emoji);
        }}
      />
    </div>
  );
};

export default EmojiPicker;
